import React from 'react';
import { Link, ListItemButton, ListItemIcon } from '@mui/material';
import classNames from 'classnames';
import { StyledListItem } from './navigation-drawer-logo.styles';
export const NavigationDrawerLogo = ({ icon, onLogoClick, className, linkDisabled, }) => {
    const handleItemClick = () => {
        onLogoClick === null || onLogoClick === void 0 ? void 0 : onLogoClick();
    };
    const listItemClassNames = classNames({
        collapsed: false,
        linkDisabled,
    }, className);
    return (<StyledListItem disablePadding>
      <ListItemButton className={listItemClassNames} component={Link} onClick={linkDisabled ? undefined : handleItemClick} disabled={linkDisabled} sx={{ cursor: linkDisabled ? 'default' : 'pointer' }}>
        <ListItemIcon>{icon}</ListItemIcon>
      </ListItemButton>
    </StyledListItem>);
};
export default NavigationDrawerLogo;
